import { LiquiditySourceDto, SimpleLiquiditySourceDto } from '../dto';
import { LiquiditySource, SimpleLiquiditySource } from '../model';

export class LiquiditySourceFactory {
  public static createSimpleFromDto(
    dto: SimpleLiquiditySourceDto,
  ): SimpleLiquiditySource {
    const liquiditySource = new SimpleLiquiditySource();
    liquiditySource.identifier = dto?.identifier || 'unknown';
    liquiditySource.readableName = dto?.readableName || '';
    liquiditySource.iconUrl = dto?.iconUrl || '';
    return liquiditySource;
  }

  public static createFromDto(dto: LiquiditySourceDto): LiquiditySource {
    const liquiditySource = new LiquiditySource();
    liquiditySource.identifier = dto?.identifier || 'unknown';
    liquiditySource.readableName = dto?.readableName || '';
    liquiditySource.iconUrl = dto?.iconUrl || '';
    liquiditySource.subLiquiditySources =
      dto?.subLiquiditySources?.map(source => this.createFromDto(source)) || [];
    liquiditySource.native = dto?.native;
    liquiditySource.enabled = true;
    return liquiditySource;
  }

  public static createFromDtos(dtos: LiquiditySourceDto[]): LiquiditySource[] {
    return dtos.map(dto => this.createFromDto(dto));
  }
}
